import styled from 'styled-components'

export const Container = styled.div<{ contentHeight?: number; open?: boolean }>`
  display: block;
  height: ${({ open, contentHeight }) =>
    open
      ? !contentHeight && contentHeight !== 0
        ? 'auto'
        : `${contentHeight}px`
      : 0};
  transition: height 0.3s ease-out;
  overflow: hidden;

  & > div {
    margin-top: -${({ open, contentHeight }) => (open ? 0 : contentHeight)}px;
  }
`
